import { render, staticRenderFns } from "./ScoreSave.vue?vue&type=template&id=c5539828&"
import script from "./ScoreSave.vue?vue&type=script&lang=js&"
export * from "./ScoreSave.vue?vue&type=script&lang=js&"
import style0 from "./ScoreSave.vue?vue&type=style&index=0&id=c5539828&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports